import { Close } from "@mui/icons-material";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  DialogContentText,
} from "@mui/material";
import { DialogProps } from "@toolpad/core/useDialogs";

const ErrorBoundaryDialog = ({
  open,
  onClose,
  payload,
}: DialogProps<string>) => {
  return (
    <Dialog fullWidth open={open} onClose={() => onClose()}>
      <DialogTitle justifyContent="center" alignItems="center" display="flex">
        <Close
          color="error"
          sx={{
            fontSize: "48px",
          }}
        />
      </DialogTitle>
      <DialogContent>
        <DialogContentText textAlign={"center"}>
          {JSON.stringify(payload)}
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          justifyContent: "center",
          display: "flex",
          alignItems: "center",
        }}
      >
        <Button onClick={() => onClose()}>Kapat</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ErrorBoundaryDialog;
